const string_table = {
  /***** Atoms *****/
  /*** DateInput ***/
  DATE_INPUT_DEFAULT_LABEL: () => "Select Date",
  DATE_INPUT_CANCEL_LABEL: () => "Cancel",
  DATE_INPUT_DONE_LABEL: () => "Done",
  DATE_INPUT_WEEKEND_DISABLED_LABEL: () => "weekends",
  DATE_INPUT_DISABLED_DAYS_DISCLAIMER: ({ disabledLabels }: { disabledLabels: Array<string> }) =>
    disabledLabels.length === 1
      ? // Handle the case there were is a single disabled day label
        `Cannot select ${disabledLabels[0]}.`
      : // Handle the case when there are many disabled day labels
        `Cannot select ${disabledLabels.slice(0, -1).join(", ")} or ${disabledLabels.slice(-1)[0]}.`,
  APP_STORE_ALT_TEXT: () => "Download from App Store",
  EMAIL_FIELD_LABEL_CONTACT_SUPPORT: () => "contact support",
  EMAIL_FIELD_LOGIN_INPUT_ARIA_EDIT_LABEL: () => "Edit email",
  EMAIL_FIELD_LOGIN_INPUT_PLACEHOLDER: () => "Email",
  EMAIL_FIELD_LOGIN_UNRECOGNIZED_EMAIL: () => "We don't recognize this email. Try another or ",
  SIGN_UP_PAGE_HEADER_LABEL: () => "Sign Up",
  SIGN_UP_HEADER_LABEL: () => "Create your account",
  SIGN_UP_FIRST_NAME_LABEL: () => "First Name",
  SIGN_UP_LAST_NAME_LABEL: () => "Last Name",
  SIGN_UP_PASSWORD_LABEL: () => "Password",
  SIGN_UP_CONFIRM_PASSWORD_LABEL: () => "Confirm Password",
  SIGN_UP_BUTTON_LABEL: () => "Register",
  FORGOT_PASSWORD_LABEL_BACK: () => "Back",
  FORGOT_PASSWORD_LOGIN_ERROR_TITLE: () => "Something went wrong",
  FORGOT_PASSWORD_RESET_BACK_TO_LOGIN_ARIA_MESSAGE: () => "Back to Login page",
  FORGOT_PASSWORD_RESET_PASSWORD_BANNER_MESSAGE: ({ email }: { email: string }) =>
    `Enter the verification code sent to ${email}. Emails may take up to 15 minutes to arrive.`,
  FORGOT_PASSWORD_RESET_PASSWORD_FIELD_LABEL: () => "New Password",
  FORGOT_PASSWORD_RESET_PASSWORD_HEADER_LABEL: () => "Password Reset",
  FORGOT_PASSWORD_RESET_PASSWORD_INVALID_CODE_MESSAGE: () =>
    "Please enter a valid verification code",
  FORGOT_PASSWORD_RESET_PASSWORD_SUBMIT_LABEL: () => "Reset Password",
  FORGOT_PASSWORD_RESET_PASSWORD_VERIFICATION_LABEL: () => "Verification Code",
  FORGOT_PASSWORD_RESET_VALIDATION_LOWERCASE: () => "1 lowercase character",
  FORGOT_PASSWORD_RESET_VALIDATION_MIN_CHARACTERS: () => "8 characters minimum",
  FORGOT_PASSWORD_RESET_VALIDATION_NUMBER: () => "1 number",
  FORGOT_PASSWORD_RESET_VALIDATION_UPPERCASE: () => "1 uppercase character",
  FORGOT_PASSWORD_RESET_VERIFICATION_CODE_EXPIRED_MESSAGE: () =>
    "Select Forgot Password on the previous screen for a new code",
  FORGOT_PASSWORD_RESET_VERIFICATION_CODE_EXPIRED_TITLE: () => "Your verification code has expired",
  GOOGLE_LOGIN_UNRECOGNIZED_EMAIL: () => "We don't recognize this Google user. Try another or ",
  GOOGLE_PLAY_ALT_TEXT: () => "Download from Google Play",
  LOGIN_EMAIL_ENTRY_LOGIN_MESSAGE: () => "Log in",
  LOGIN_EMAIL_ENTRY_LOGIN_LABEL_ENTER_PASSWORD: () => "Enter Password",
  LOGIN_EMAIL_ENTRY_LABEL_OR: () => "OR",
  LOGIN_EMAIL_ENTRY_LOGIN_LABEL_CONTINUE_WITH_GOOGLE: () => "Continue with Google",
  LOGIN_FOOTER_SUPPORT: () => "Support",
  LOGIN_FOOTER_TERMS_OF_SERVICE: () => `Terms of Service`,
  LOGIN_FORM_CONTAINER_SWING_LOGO_ALT_TEXT: () => "Swing Logo",
  LOGIN_INCORRECT_USER_TYPE_LABEL_MOBILE_SWING_SCHOOLS: () =>
    "Swing Subs for Substitute Teachers app",
  LOGIN_INCORRECT_USER_TYPE_LABEL_MOBILE_SWING_SUBS: () => "Swing Schools for School Admins app",
  LOGIN_INCORRECT_USER_TYPE_SWING_SCHOOLS: () => "Looks like you're a sub. Try logging into our",
  LOGIN_INCORRECT_USER_TYPE_SWING_SUBS: () =>
    "Looks like you're a school admin. Try logging into our",
  LOGIN_INCORRECT_USER_TYPE_LABEL_WEB_SWING_SCHOOLS: () =>
    "Swing Subs for Substitute Teachers website",
  LOGIN_INCORRECT_USER_TYPE_LABEL_WEB_SWING_SUBS: () => "Swing Schools for School Admins website",

  LOGIN_LAYOUT_SPLASH_IMAGE_ALT_TEXT: () => "Stock image of a substitute teacher in a classroom",
  LOGIN_TITLE_SWING_SCHOOLS_HEADER: () => "Swing Schools for",
  LOGIN_TITLE_SWING_SCHOOLS: () => "School Administrators",
  LOGIN_TITLE_SWING_SUBS_HEADER: () => "Swing Subs for",
  LOGIN_TITLE_SWING_SUBS: () => "Substitute Teachers",
  LOGIN_WITH_PASSWORD_LABEL_CONTACT_SUPPORT: () => "contact support",
  LOGIN_WITH_PASSWORD_LOGIN_ATTEMPTS_EXCEEDED: () =>
    "Your account has been temporarily locked. Try again in 15 minutes.",
  LOGIN_WITH_PASSWORD_LOGIN_BUTTON_LABEL: () => "Log In",
  LOGIN_WITH_PASSWORD_LOGIN_ERROR_MESSAGE: ({
    contactSupportLink,
  }: {
    contactSupportLink: string;
  }) =>
    `Please try again later or <a target="_blank" rel="noreferrer" href=${contactSupportLink}>contact support</a> for assistance.`,
  LOGIN_WITH_PASSWORD_LOGIN_FORGOT_PASSWORD_LABEL: () => "Forgot Password",
  LOGIN_WITH_PASSWORD_LOGIN_ERROR_TITLE: () => "Something went wrong",
  LOGIN_WITH_PASSWORD_LOGIN_INCORRECT_PASSWORD: () => "Sorry, we don't recognize that password.",
  LOGIN_WITH_PASSWORD_LOGIN_PASSWORD_LABEL: () => "Password",
  LOGIN_WITH_PASSWORD_RESET_PASSWORD_SUCCESS_MESSAGE: () =>
    "We successfully reset your password. Log in with your new password",
  LOGIN_WITH_PASSWORD_LOGIN_WELCOME_BACK_MESSAGE: () => "Welcome back",
  PASSWORD_FIELD_LOGIN_PASSWORD_SHOW_LABEL: () => "Show",
  PASSWORD_FIELD_LOGIN_PASSWORD_HIDE_LABEL: () => "Hide",
  PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_SHOW_LABEL: () => "Show password",
  PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_HIDE_LABEL: () => "Hide password",
  PASSWORD_VALIDATION_FIELD_RESET_PASSWORD_VALIDATION_LABEL: () => "All passwords must have",
  SUB_PROFILE_ABOUT_EDIT_EMPTY: () =>
    "This is your time to shine! Subs who fill out their profile are more likely to be accepted for long-term requests",
  SUB_PROFILE_ABOUT_HEADER: () => "About Me",
  SUB_PROFILE_CLASSROOM_PREFERENCES_HEADER: () => "Classroom Preferences",
  SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_GRADE_LEVEL: () => "Grade Level",
  SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_LANGUAGES: () => "Languages",
  SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_SUBJECTS: () => "Subjects",
  SUB_PROFILE_CONTACT_IMAGE_ALT: () => "generic avatar user icon",
  SUB_PROFILE_CONTACT_EDIT_BUTTON: () => "Edit",
  SUB_PROFILE_CONTACT_SWING: () => "Swing",
  SUB_PROFILE_CONTACT_HERO: () => "Hero",
  SUB_PROFILE_EDUCATION_EDIT_EMPTY: () => "Showcase your education",
  SUB_PROFILE_EDUCATION_HEADER: () => "Education",
  SUB_PROFILE_FEEDBACK_FROM_SCHOOLS_HEADER: () => "Feedback from Schools",
  SUB_PROFILE_QUALIFICATIONS_HEADER: () => "Qualifications",
  SUB_PROFILE_QUALIFICATIONS_SKILL_BUILDER_SUB_LABEL: () => "Skill Builder",
  SUB_PROFILE_QUALIFICATIONS_STAR_SUB_LABEL: () => "Star Sub",
  SUB_PROFILE_NO_INFORMATION: () => "No information provided",
  SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_BUTTON_TEXT: () => "Add Another Experience",
  SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_EDIT_EMPTY: () => "Showcase your work experience",
  SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_HEADER: () => "Work Experience",
  SUB_PROFILE_SWING_EXPERIENCE_DAYS_WORKED: () => "days worked",
  SUB_PROFILE_SWING_EXPERIENCE_HEADER: () => "Swing Experience",
  SUB_PROFILE_SWING_EXPERIENCE_POSITIVE_REVIEWS: () => "positive reviews",
  SUB_PROFILE_SWING_EXPERIENCE_SCHOOLS_WORKED: () => "schools worked",
  SUB_PROFILE_SWING_EXPERIENCE_TIMES_PREFERRED: () => "times preferred",
  SUB_PROFILE_NO_IMAGE_TEXT: () =>
    "Upload a picture to increase your chances of being selected by a school",

  SWING_HERO_SUPPORT_ARTICLE_LINK_W2: () => "en/articles/11120000-swing-heroes-for-subs",
  SWING_HERO_SUPPORT_ARTICLE_LINK_1099: () => "/en/articles/11119997-swing-heroes",

  SWING_HERO_SWING_SUB: () => "Swing Sub",
  SWING_HEROES: () => "Swing Heroes",
  SWING_HERO_INELIGIBLE_CONTACT_SUPPORT_START: () => "Contact support",
  SWING_HERO_INELIGIBLE_CONTACT_SUPPORT_END: () =>
    "if you have any questions or want additional details.",
  SWING_HERO_INELIGIBLE_STATUS_SUB_TEXT: () =>
    "At this time you are ineligible for Swing Hero status due to a no-show or a negative feedback incident.",
  SWING_HERO_INELIGIBLE_LIST_TITLE: () => "Tips to get back on track",
  SWING_HERO_INELIGIBLE_LIST_FIRST_ITEM: () => "Work and receive positive feedback",
  SWING_HERO_INELIGIBLE_LIST_SECOND_ITEM: () => "Show up on time and ready to teach",
  SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_PREFIX: () => "Complete",
  SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_BUTTON: () => "Skill Builders",
  SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_SUFFIX: () => "to improve your skills.",
  SWING_HERO_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_TITLE: () => "How to earn a high score",
  SWING_HERO_LEARN_MORE_ABOUT: () => "Learn more about",

  SWING_HERO_SCORE_PROGRESS_TITLE: () => "Your Score",
  SWING_HERO_YOUR_STATUS: () => "Your Status",
  SWING_HERO_ELIGIBLE_SUBTEXT: () => "You're on your way to Swing Hero status",
  SWING_HERO_INELIGIBLE_SUBTEXT: () =>
    "At this time you are inelligble for Swing Hero status due to a recent no-show or negative feedback incident.",
  SWING_HERO_MAINTAIN_STATUS_TITLE: () => "How to maintain Swing Hero status",
  SWING_HERO_HOW_TO_BECOME_TITLE: () => "How to become a Swing Hero",
  SWING_HERO_TIPS_TITLE: () => "Tips to get back on track",
  SWING_HERO_PLACEHOLDER_CONTENT: () => "Content will be determined later based on status.",

  // Shared action items
  SWING_HERO_MAINTAIN_PROFESSIONAL_BEHAVIOR: () => "Show up on time and be professional",
  SWING_HERO_IMPROVE_SKILLS_WITH_SKILL_BUILDER: ({
    skillBuilderUrl,
  }: {
    skillBuilderUrl: string;
  }) =>
    `Improve skills with <a href="${skillBuilderUrl}" target="_blank" rel="noopener noreferrer">Skill Builder</a>`,

  // List descriptions
  SWING_HERO_QUALIFYING_FOR_DESCRIPTION: () => "You're qualifying for",
  SWING_HERO_TO_QUALIFY_FOR_DESCRIPTION: () => "To qualify for",

  // Perks
  SWING_HERO_PRIORITY_ACCESS_PERK: () => "Priority access for certain requests",
  SWING_HERO_INCREASED_EARNINGS_PERK: () => "Increased earning potential",

  // Footer text
  SWING_HERO_LEARN_MORE_ABOUT_HEROES: ({ heroesUrl }: { heroesUrl: string }) =>
    `Learn more about <a href="${heroesUrl}" target="_blank" rel="noopener noreferrer">Swing Heroes</a>.`,

  SWING_HERO_CONTACT_SUPPORT_QUESTIONS: ({ supportUrl }: { supportUrl: string }) =>
    `<a href="${supportUrl}" target="_blank" rel="noopener noreferrer">Contact support</a> for additional details.`,
  // URLs
  SWING_HERO_SKILL_BUILDER_URL: () => "/more/skill-builder/swing",

  /** Aria labels **/
  ARIA_LABEL_SELECTED: () => "selected",
  ARIA_LABEL_DESELECTED: () => "deselected",

  /** Labels **/
  LABEL_SELECT: () => "Select",
  LABEL_ALIASED: () => "Aliased as",
};

// type GetMatchingKeys<Map extends Record<string, () => string>, Shape> = {
//   [Key in keyof Map]: Parameters<Map[Key]> extends Shape ? Key : never;
// }[keyof Map];

// type KeyWithEmptyFnParam = GetMatchingKeys<typeof string_table, []>;

// export function msg<Key extends KeyWithEmptyFnParam>(key: Key) {
//   return string_table[key]();
// }

/**
 * Given a translation key, optionally with arguments, returns the translated
 * string.
 */
export function translate<Key extends keyof typeof string_table>(
  key: Key,
  ...args: Parameters<(typeof string_table)[typeof key]>
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return string_table[key](args[0] as any);
}

/**
 * @deprecated Use `translate` instead.
 */
export default function msg<Key extends keyof typeof string_table>(
  key: Key,
  ...args: Parameters<(typeof string_table)[typeof key]>
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return string_table[key](args[0] as any);
}
